import * as React from "react";

/* The dialog animates out before the host unmounts it, so the outcome waits in a ref
 * until onOpenChangeComplete reports the close finished. */
export default function useComposerClose({ isDirty, onClose }) {
  const [open, setOpen] = React.useState(true);
  const [isConfirmingDiscard, setConfirmingDiscard] = React.useState(false);
  const outcome = React.useRef(undefined);

  const close = React.useCallback((result) => {
    outcome.current = result;
    setOpen(false);
  }, []);

  const requestClose = React.useCallback(
    () => (isDirty ? setConfirmingDiscard(true) : close()),
    [isDirty, close],
  );

  const onClosed = React.useCallback(
    () => onClose?.(outcome.current),
    [onClose],
  );

  return {
    open,
    close,
    requestClose,
    onClosed,
    discard: {
      open: isConfirmingDiscard,
      onConfirm: () => {
        setConfirmingDiscard(false);
        close();
      },
      onCancel: () => setConfirmingDiscard(false),
    },
  };
}
